import { Text } from '~/components/ui/Text';
import { SettingsStages } from '../../models/Settings';
import { setActiveSettingsState, useLayoutDispatch } from '../../redux';
import { AppBackButton } from '../AppBackButton';
import {
	StyledContainer,
	StyledGroup,
	StyledHead,
	StyledItem,
} from './AppSettingsGlobal.styled';

const AppSettingsGlobal = () => {
	const dispatch = useLayoutDispatch();

	return (
		<div>
			<StyledHead>
				<AppBackButton
					onClick={() => dispatch(setActiveSettingsState(SettingsStages.MAIN))}
				/>
				<Text>Основные настройки</Text>
			</StyledHead>
			<StyledContainer tabIndex={-1}>
				<StyledGroup>
					<StyledItem>
						<Text>Версия ПО</Text>
						<Text>0.0.1 (Beta)</Text>
					</StyledItem>
					<StyledItem>
						<Text>Название модели</Text>
						<Text>iPho 1</Text>
					</StyledItem>
					<StyledItem>
						<Text>Номер модели</Text>
						<Text>MW727LL/A</Text>
					</StyledItem>
					<StyledItem>
						<Text>Серийный номер</Text>
						<Text>XJAA788933XA</Text>
					</StyledItem>
				</StyledGroup>
				<StyledGroup>
					<StyledItem>
						<Text>Адрес Wi-Fi</Text>
						<Text>40:4D:7F:66:13:24</Text>
					</StyledItem>
					<StyledItem>
						<Text>IMEI</Text>
						<Text>35 723951 845234 2</Text>
					</StyledItem>
					<StyledItem>
						<Text>Прошивка модема</Text>
						<Text>2.01.25</Text>
					</StyledItem>
					<StyledItem>
						<Text>Имя устройства</Text>
						<Text>CCDPlanet WW</Text>
					</StyledItem>
				</StyledGroup>
			</StyledContainer>
		</div>
	);
};

export { AppSettingsGlobal };
